import * as types from './actionTypes';
import axios from 'axios';
import { getHeader } from '../helper';

function getPayOutListRequest() {
    return {
        type: types.LOAD_PAY_OUT_LIST_REQUEST
    }
}

function getPayOutListReceive(data) {
    return {
        type: types.LOAD_PAY_OUT_LIST_SUCCESS,
        data: data
    }
}

function getPayOutListError(messages) {
    return {
        type: types.LOAD_PAY_OUT_LIST_FAILURE,
        messages
    }
}

export function getPayOutList() {
    
    return function (dispatch) {
        dispatch(getPayOutListRequest())

        return axios.get(`${window.siteUrl}/api/v1/pay_out/?status=3`,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(getPayOutListReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getPayOutListError", err.data, err.status, err.headers);
                dispatch(getPayOutListError(err.data));
            }
        });
    }
}



export function payOut(params,  afterSuccess, afterError) {
    return function (dispatch) {

        return axios.post(`${window.siteUrl}/api/v1/pay_out/`, params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(afterSuccess) afterSuccess(response.data);
        })
        .catch(function (error) {
            if(afterError) afterError(error);
            console.error("payOutError", error);
        });
    }
}



function payOutConfirmRequest() {
    return {
        type: types.PAY_OUT_CONFIRM_REQUEST
    }
}

function payOutConfirmReceive(data) {
    return {
        type: types.PAY_OUT_CONFIRM_SUCCESS,
        data
    }
}

function payOutConfirmError(messages) {
    return {
        type: types.PAY_OUT_CONFIRM_FAILURE,
        messages
    }
}

export function payOutConfirm(params, afterSuccess, afterError) {
    return function (dispatch) { 
        dispatch(payOutConfirmRequest());

        return axios.post(
            `${window.siteUrl}/api/v1/pay_out/${params.id}/accept_confirm/`, {
                code: params.code,
            },
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(afterSuccess) afterSuccess(response.data);
            if(response.data.status) {
                dispatch(payOutConfirmReceive(params));
            }
        })
        .catch(function (error) {
            if(afterError) afterError(error.response.data);
            dispatch(payOutConfirmError());
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/payOutActions.js